module.exports = __webpack_public_path__ + "static/media/gameover.01fa41b7.mp3";